import { EndpointCardBlockCombinedProps } from './types';

const usePresenter = (props: EndpointCardBlockCombinedProps): EndpointCardBlockCombinedProps => {
  return props;
};

export default usePresenter;
